<template>
    <div>
        <div class="calendar">
            <div class="box">
                <h2>{{roomName}}</h2>
                <a-calendar @select="onSelect" valueFormat="YYYY-MM-DD" >
                    <ul slot="dateCellRender" slot-scope="value" class="events">
                        <a-icon v-show="isCheck(value)" type="check" style="color:green"/>
                        <li v-for="item in getListData(value)" :key="item.content">
                            <a-popover :title="item.content">
                                <template slot="content">
                                    <p>预约联系人：{{item.orderPeople}}</p>
                                    <p>联系人电话：{{item.orderPeoplePhone}}</p>
                                </template>
                                <a-badge :status="item.type" :text="item.content" />
                            </a-popover>
                        </li>
                    </ul>
                </a-calendar>
            </div>
            <div class="box">
                <div class="add">
                    <a-button type="primary" style="margin-left:0;margin:0px 0px 0px 20px" @click="$router.push('/admin/office/administration/meetingRooms')"><a-icon type="left" />返回</a-button>
                    <a-button type="primary" v-if="type=='approve'"  style="margin-left:auto;margin:0px 20px 0px 0px" @click="selectedRowKeys[0] == null ? selectedCheck() : showBatchModal('批量审批')"><a-icon type="check" />批量审批</a-button>
                    <a-button v-if="type=='apply'" type="primary" @click="showModal('','新增')">
                        <a-icon type="plus"/>新增
                    </a-button>
                    <a-radio-group defaultValue = "" size="large" style="margin-right:auto;" :v-model="approvalStatus" @change="onStatusChange">
                        <a-radio-button value="apply">
                        待审批
                        </a-radio-button>
                        <a-radio-button value="agree">
                        已审批
                        </a-radio-button>
                        <a-radio-button value="reject">
                        已驳回
                        </a-radio-button>
                        <a-radio-button value="">
                        全部
                        </a-radio-button>
                    </a-radio-group>
                    
                </div>
                <a-table 
                rowKey='id'
                :customRow="onClickRow"
                :columns="columns" 
                :data-source="data"
                :pagination='pagination'
                :loading="loading"
                @change="handleTableChange"
                :row-selection="{ type:'checkbox',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                bordered>
                    <template slot="operation" slot-scope="text, record, index">
                        <a-button type="primary" v-if="type=='apply'" class="btn" size='small' @click="showModal(record,'编辑')"><a-icon type="edit" />编辑</a-button>
                        <a-popconfirm
                                v-if="type=='apply'"
                                title="确定删除？"
                                ok-text="是"
                                cancel-text="否"
                                @confirm="sub('del',record.id)"
                                @cancel="cancel"
                            >
                            <a-button type="primary" class="btn" size='small' ><a-icon type="delete" />删除</a-button>
                        </a-popconfirm>
                        <a-button type="primary" v-if="type=='approve' && record.approvalStatus=='apply'" class="btn" size='small' @click="showModal(record,'审批')"><a-icon type="check" />审批</a-button>
                        <a-button type="primary" v-if="$store.state.user.name.indexOf(record.orderPeople) > -1" class="btn" size='small' @click="sub('cancel',record.id)"><a-icon type="close" />撤销</a-button>
                    </template>
                </a-table>
            </div>
            
        </div>
        <a-modal
        :title="title"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
        :confirm-loading="confirmLoading"
        width='35rem'
        >
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                取消
                </a-button>
                <a-button key="submit" v-show="operateType=='add'" type="primary" :loading="loading" @click="sub('add')">
                确定
                </a-button>
                <a-button key="submit" v-show="operateType=='edit'" type="primary" :loading="loading" @click="sub('edit')">
                确定
                </a-button>
                <a-button key="submit" v-show="operateType=='approve'" type="primary" :loading="loading" @click="sub('reject')">
                驳回
                </a-button>
                <a-button key="submit" v-show="operateType=='approve'" type="primary" :loading="loading" @click="sub('approve')">
                通过
                </a-button>
            </template>

            <div class="info-main">
                <div class="input-box">
                    <p>会议时间：</p>
                    <a-range-picker
                        style="width:23rem"
                        v-model="meetingTimeArr"
                        :show-time="{ format: 'HH:mm' }"
                        format="YYYY-MM-DD HH:mm"
                        :placeholder="['开始时间', '结束时间']"
                        @change="onChange"
                        @ok="onOk"
                    />
                </div>
                <div class="input-box">
                    <p>会议名称：</p>
                    <a-input class="input" v-model="info.meetingName"></a-input>
                </div>
                <div class="input-box">
                    <p>参会人数：</p>
                    <a-input class="input" v-model="info.peopleNum"></a-input>
                </div>
                <div class="input-box" v-show="operateType=='approve'">
                    <p>是否审核：</p>
                    <a-input class="input" :value='agree' disabled></a-input>
                </div>
                <div class="input-box">
                    <p>预约联系人：</p>
                    <a-input class="input" v-model="info.orderPeople"></a-input>
                </div>
                <div class="input-box">
                    <p>预约联系人电话：</p>
                    <a-input class="input" v-model="info.orderPeoplePhone"></a-input>
                </div>
                <div class="input-box" v-show="operateType=='approve'">
                    <p>申请时间：</p>
                    <a-input class="input" v-model="info.createTime" disabled></a-input>
                </div>
                <div class="input-box">
                    <p>安全检查人：</p>
                    <a-input class="input" :value='safetyInspector' disabled></a-input>
                </div>
                <div class="input-box">
                    <p>备注：</p>
                    <a-textarea class="input" v-model="info.remark" :rows="3"></a-textarea>
                </div>
                <div class="input-box" v-show="operateType=='approve'">
                    <p>审批意见：</p>
                    <a-textarea class="input" v-model="approveInfo.approvalComments" :rows="3"></a-textarea>
                </div>
            </div>
        </a-modal>


        <a-modal
        :title="batchTitle"
        :visible="batchVisible"
        @ok="handleOk"
        @cancel="batchHandleCancel"
        :confirm-loading="batchConfirmLoading"
        width='35rem'
        >
            <template slot="footer">
                <a-button key="back" @click="batchHandleCancel">
                取消
                </a-button>
                <a-button key="submit" type="primary" :loading="loading" @click="batchSub('reject')">
                驳回
                </a-button>
                <a-button key="submit" type="primary" :loading="loading" @click="batchSub('agree')">
                通过
                </a-button>
            </template>

            <div class="info-main">
                <div class="input-box">
                    <p>审批意见：</p>
                    <a-textarea class="input" v-model="batchApproveInfo.approvalComments" :rows="3"></a-textarea>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { reservationList,approve,add,edit,del,cancel,batchApprove } from '@/baseAPI/office/meetingRooms'
import { selectedMultiCheck } from '@/baseAPI/util'
export default {
    data(){
        return {
            data:[],
            columns:[
                {
                    title: '会议时间',
                    dataIndex: '',
                    width:'17rem',
                    customRender: (text, row, index) => {
                        if(row.startTime.substr(0,10) == row.endTime.substr(0,10)){
                            return row.startTime.substr(0,16).replace('-','年').replace('-','月').replace(' ','日')+'至'+row.endTime.substr(11,5)
                        }
                        return row.startTime.substr(0,16)+'至'+row.endTime.substr(0,16)
                    },
                },
                {
                    title: '会议名称',
                    dataIndex: 'meetingName',
                    width:'10rem',
                },
                {
                    title: '预约人',
                    width:'10rem',
                    customRender: (text, row, index) => {
                        if(row.orderPeoplePhone != null && row.orderPeoplePhone != ''){
                            return row.orderPeople+'('+row.orderPeoplePhone+')'
                        }
                        return row.orderPeople
                    },
                },
                {
                    title: '状态',
                    dataIndex: 'approvalStatus',
                    width:'6rem',
                    customRender: (text, row, index) => {
                        let result
                        if(text == 'apply'){
                            result = '已申请'
                        }else if(text == 'agree'){
                            result = '已审批'
                        }else if(text == 'reject'){
                            result = '已驳回'
                        }else if(text == 'cancel'){
                            result = '已撤销'
                        }else{
                            result = text
                        }
                        return result
                    },
                },
                {
                    title: '操作',
                    width:'5rem',
                    dataIndex:'operation',
                    scopedSlots: { customRender: 'operation' },
                }
            ],
            editingKey: '',
            roomId:'',
            visible: false,
            confirmLoading: false,
            info:{
                roomId: "",
                meetingName: "",
                peopleNum: "",
                orderPeople: "",
                orderPeoplePhone: "",
            },
            meetingTimeArr:[],
            agree:'否',
            title:'',
            approveInfo:{
                applyId:'',
                approvalComments:'',
                status:''
            },
            addInfo:{
                	roomId: "",
                    meetingName: "",
                    peopleNum: "",
                    orderPeople: "",
                    orderPeoplePhone: "",
                    startTime: "",
                    endTime: "",
                    applyId:""
            },
            okText:'确定',
            cancelText:'取消',
            operateType:'',
            selectCalendar:'',
            calendarData:[],
            pagination:{
                    current: 1,//当前页数
                    pageSize: 5,
                    pageSizeOptions: ['5','10', '20', '100'],
                    showTotal: (total, range) => {
                    return " 共" + total + "条"
                    },
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0
                },
            safetyInspector:'',
            roomName:'',
            type:'',
            approvalStatus:'',
            selectedRowKeys: [],
            batchVisible: false,
            batchConfirmLoading: false,
            batchTitle:'',
            batchApproveInfo:{
                approvalComments:'',
                ids:[]
            },
            loading:false
        };
    },
    mounted(){
        this.roomId=this.$route.query.roomId;
        this.safetyInspector=this.$route.query.safetyInspector == '()' ? '' : this.$route.query.safetyInspector;
        this.roomName=this.$route.query.roomName;        
        this.type=this.$route.query.type;
        this.fetch()
    },
    methods: {
        selectedCheck(){
            selectedMultiCheck()
        },
        handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize=pagination.pageSize;
                this.pagination = pager;
                this.fetch();
            },
        batchSub(operation){
            this.batchApproveInfo.ids = this.selectedRowKeys;
            batchApprove(operation,this.batchApproveInfo).then(res=>{
                if(res.data.success){
                    this.$notification['success']({
                        message: '成功',
                        description:'批量审核成功',
                    });
                }else{
                    this.$notification['error']({
                        message: '失败',
                        description:res.data.errorMessage,
                    });
                }
                this.fetch();
            })
            this.batchVisible = false;
        },
        onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            },
        onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.courseId=record.courseInfoId
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
        onStatusChange(e){
            this.approvalStatus=e.target.value;
            this.fetch();
            console.log('approvalStatus:'+this.approvalStatus)
        },
        isCheck(value){
            if(value.format('YYYY-MM-DD') == this.selectCalendar){
                return true
            }else{
                return false
            }
        },
        onSelect(value) {
            if(this.selectCalendar == value){
                this.selectCalendar = ''
                this.fetch()
            }else{
                this.selectCalendar=value
                this.fetch('startTime='+this.selectCalendar+' 00:00:00'+'&endTime='+this.selectCalendar+' 23:59:59')
            }
        },
        getListData(value) {
            let date = value.format('YYYY-MM-DD');
            let listData = [];
            this.calendarData.forEach(e=>{
                if( date >= e.startTime.substr(0,10) && date <= e.endTime.substr(0,10) && e.approvalStatus != 'cancel'){
                    listData.push({ type: 'warning', content: e.meetingName,orderPeople:e.orderPeople,orderPeoplePhone:e.orderPeoplePhone })
                }
            })
            // switch (value.date()) {
            //     case 8:
            //     listData = [
            //         { type: 'warning', content: 'This is warning event.' },
            //         { type: 'success', content: 'This is usual event.' },
            //     ];
            //     break;
            //     case 10:
            //     listData = [
            //         { type: 'warning', content: 'This is warning event.' },
            //         { type: 'success', content: 'This is usual event.' },
            //         { type: 'error', content: 'This is error event.' },
            //     ];
            //     break;
            //     case 15:
            //     listData = [
            //         { type: 'warning', content: 'This is warning event' },
            //         { type: 'success', content: 'This is very long usual event。。....' },
            //         { type: 'error', content: 'This is error event 1.' },
            //         { type: 'error', content: 'This is error event 2.' },
            //         { type: 'error', content: 'This is error event 3.' },
            //         { type: 'error', content: 'This is error event 4.' },
            //     ];
            //     break;
            //     default:
            // }
            return listData || [];
        },
        fetch(params){
            this.loading=true
            reservationList(this.roomId,params + '&approvalStatus='+this.approvalStatus).then(res=>{
                this.data = res.data
                if(params == null){
                    this.calendarData = this.data
                }
                this.loading=false
            })
        },
        getMonthData(value) {
            if (value.month() === 8) {
                return 1394;
            }
        },
        showModal(value,text) {
            if(text == '审批'){
                this.operateType='approve'
                this.approveInfo.applyId=value.id
                this.info=value
                this.agree = this.info.approvalStatus=='agree' ?'是':'否'
                this.meetingTimeArr = []
                this.meetingTimeArr.push(this.info.startTime)
                this.meetingTimeArr.push(this.info.endTime)
            }else if(text == '新增'){
                this.operateType='add'
                this.meetingTimeArr = []
                this.info.meetingName=''
                this.info.peopleNum=''
                this.info.orderPeople=this.$store.state.user.name;
                
                this.info.orderPeoplePhone=this.$store.state.user.telephone
                this.info.remark=''
            }else if(text == '编辑'){
                this.operateType='edit'
                this.addInfo.applyId=value.id
                this.info=value
                this.agree = this.info.approvalStatus=='agree' ?'是':'否'
                this.addInfo.startTime=this.info.startTime
                this.addInfo.endTime=this.info.endTime
                this.meetingTimeArr = []
                this.meetingTimeArr.push(this.info.startTime)
                this.meetingTimeArr.push(this.info.endTime)
            }
            this.visible = true;
            this.title='会议室预约-'+text
        },
        showBatchModal(text) {
            this.batchVisible = true;
            this.batchTitle='会议室预约-'+text
        },
        handleOk(e) {
            this.approveInfo.status='1'
            this.ModalText = 'The modal will be closed after two seconds';
            this.confirmLoading = true;
            this.visible = false;
            this.confirmLoading = false;
            
        },
        handleCancel(e) {
            this.approveInfo.status='2'
            console.log('Clicked cancel button');
            this.confirmLoading = true;
            this.visible = false;
            this.confirmLoading = false;
        },
        batchHandleCancel(e) {
            this.batchVisible = false;
            this.batchConfirmLoading = false;
        },
        onChange(value, dateString) {
            this.addInfo.startTime=dateString[0]+':00'
            this.addInfo.endTime=dateString[1]+':00'
            console.log('Selected Time: ', value);
            console.log('Formatted Selected Time: ', dateString);
        },
        onOk(value) {
            console.log('onOk: ', value);
        },
        sub(type,applyId){
            if(type=='add' || type=='edit'){
                this.addInfo.roomId = this.roomId
                this.addInfo.meetingName = this.info.meetingName
                this.addInfo.peopleNum = this.info.peopleNum
                this.addInfo.orderPeople = this.info.orderPeople
                this.addInfo.orderPeoplePhone = this.info.orderPeoplePhone
                this.addInfo.remark=this.info.remark
                if(type =='add'){
                    add(this.addInfo).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'新增成功',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        this.fetch()
                    })
                }else{
                    edit(this.addInfo).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'编辑成功',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        this.fetch()
                    })
                }
                this.visible = false;
            }else if(type=='approve' || type == 'reject'){
                this.approveInfo.status= (type =='approve' ? '1':'2');
                approve(this.approveInfo).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'审核成功',
                        });
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                    this.fetch()
                })
                this.visible = false;
            }else if(type=='del'){
                del(applyId).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除成功',
                        });
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                    this.fetch()
                })
            }else if(type=='cancel'){
                cancel(applyId).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'撤销成功',
                        });
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                    this.fetch()
                })
            }
        }
  },
};
</script>
<style scoped>
    .events {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .events .ant-badge-status {
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        text-overflow: ellipsis;
        font-size: 12px;
    }
    .notes-month {
        text-align: center;
        font-size: 28px;
    }
    .notes-month section {
        font-size: 28px;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .calendar{
        display: flex;
    }
    .calendar .box{
        width: 49%;
    }

    .info-main{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .info-main .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1rem;
        position: relative;
    }
    .info-main .input-box p{
        width: 8rem;
        text-align: right;
    }
    .info-main .input-box .input{
        /* width: calc(100% - 0rem); */
        width: 23rem;
    }

    .box .add{
        display: flex;
        flex-direction:row-reverse;
        margin-bottom: 1rem;
        position: relative;
    }

    .btn{
        margin-bottom: 0.5rem;
    }
</style>
